import { useContext } from "react";
import { diplomasActionTypes } from "../reducer/resume-diplomas-reducer";
import { ResumeContext } from "../resume-context";

function useResumeDiplomasHandlers() {
    const { dispatch } = useContext( ResumeContext );

    return {
        handleAdd: () => {
            dispatch( {
                type: diplomasActionTypes.ADD_DIPLOMA,
                item: {
                    order: -1,
                    from: '',
                    to: '',
                    isCurrent: false,
                    schoolName: false,
                    diplomaTitle: '',
                    educationLevel: null
                },
            } );
        },
        handleChange: ( diploma ) => {
            dispatch( {
                type: diplomasActionTypes.CHANGE_DIPLOMA,
                item: diploma,
            } );
        },
        handleRemove: ( diploma ) => {
            dispatch( {
                type: diplomasActionTypes.REMOVE_DIPLOMA,
                item: diploma,
            } );
        },
        handleMoveUp: ( diploma ) => {
            dispatch( {
                type: diplomasActionTypes.MOVE_DIPLOMA_UP,
                item: diploma,
            } );
        },
        handleMoveDown: ( diploma ) => {
            dispatch( {
                type: diplomasActionTypes.MOVE_DIPLOMA_DOWN,
                item: diploma,
            } );
        },
    };
}

export default useResumeDiplomasHandlers
